'use strict';

const helper = require('../../helper');

const billingFormEl = document.getElementById('dwfrm_billing');
const nonInstantLPMFields = billingFormEl?.querySelectorAll('.js-nlpm-field');
const nonInstantLPMFieldsToDisable = nonInstantLPMFields && Array.from(nonInstantLPMFields);
const nonInstantLPMs = window.braintreeConstants.PAYMENT_METHOD_IDS_NON_INSTANT_LPM;

/**
 * Returns Braintree LPM configs
 * @returns {Object} Braintree LPM configs
 */
function getBraintreeLpmConfigs() {
    const $braintreeLpmButton = document.querySelector('.js-lpm-fallback, .js-braintree-lpm-button');

    let braintreeLpmConfigs = {};

    try {
        if ($braintreeLpmButton) {
            braintreeLpmConfigs = helper.tryParseJSON($braintreeLpmButton.getAttribute('data-braintree-config'));
        }
    } catch (error) {
        return braintreeLpmConfigs;
    }

    return braintreeLpmConfigs;
}

/**
 * Disables non instant LPMs related inputs if non instant LPM payment tab is not active
 */
function handleNonInstantDisabledAttr() {
    const paymentOptionsEls = document.querySelectorAll('.payment-options .nav-link');
    const activeTabEl = document.querySelector('.nav-link.active');

    const handleDisabledAttribute = (element) => {
        const isNonInstantLPMTabActive = Object.values(nonInstantLPMs).includes(element.parentElement.dataset.methodId);

        nonInstantLPMFieldsToDisable
            .filter((field) => !field.disabled || isNonInstantLPMTabActive)
            .forEach((field) => {
                field.disabled = !isNonInstantLPMTabActive;
            });
    };

    handleDisabledAttribute(activeTabEl);

    paymentOptionsEls.forEach((element) => {
        element.addEventListener('click', () => handleDisabledAttribute(element));
    });
}

module.exports = {
    getBraintreeLpmConfigs,
    handleNonInstantDisabledAttr
};
